<template>
  <div id="accountManagement">
    <commonSearchBar>
      <template #inputRegion>
        <div class="col">
          <div class="label">客户名称</div>
          <div class="inputBox">
            <el-input v-model="from.input" placeholder="请输入内容" />
          </div>
        </div>
        <div class="col">
          <div class="label">客商银行账号</div>
          <div class="inputBox">
            <el-input v-model="from.input" placeholder="请输入内容" />
          </div>
        </div>
      </template>
      <template #buttons>
        <el-button type="warning" plain>重置</el-button>
        <el-button type="primary" plain>搜索</el-button>
      </template>
    </commonSearchBar>
    <div class="common_contentBox">
      <el-button type="primary" @click="dialogVisible = true">添加客商信息</el-button>
      <commonTable ref="accountManagementTable" />
    </div>
    <el-dialog
      title="添加客商"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleDialogClose"
    >
      <el-form label-position="top" label-width="80px" :model="formData">
        <el-form-item label="客商名称:">
          <el-input v-model="formData.userName" />
        </el-form-item>
        <el-form-item label="银行账户名:">
          <el-input v-model="formData.projectName" />
        </el-form-item>
        <el-form-item label="开户银行:">
          <el-input v-model="formData.projectName" />
        </el-form-item>
        <el-form-item label="开户支行:">
          <el-input v-model="formData.projectName" />
        </el-form-item>
        <el-form-item label="银行账号:">
          <el-input v-model="formData.projectName" />
        </el-form-item>
        <el-form-item label="是否为关联单位:">
          <el-radio-group v-model="formData.resource">
            <el-radio label="是" />
            <el-radio label="否" />
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import commonSearchBar from '@/components/commonSearchBar';
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
export default {
  name: 'AccountManagement',
  data () {
    return {
      from: {},
      tableData: [{}],
      dialogVisible: false,
      formData: {}
    };
  },
  components: {
    commonSearchBar,
    commonTable
  },
  computed: {},
  methods: {
    handleDialogClose () {

    },
    setTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('客商名称')
          ._width('200')
          ._data('id')
      );
      tableRow.push(
        new TableColumns()
          ._title('银行账户')
          ._width('150')
          ._data('aa1')
      );
      tableRow.push(
        new TableColumns()
          ._title('银行账号')
          ._width('150')
          ._data('aa2')
      );
      tableRow.push(
        new TableColumns()
          ._title('开户行')
          ._width('150')
          ._data('aa3')
      );
      tableRow.push(
        new TableColumns()
          ._title('开户支行')
          ._width('150')
          ._data('aa4')
      );
      tableRow.push(
        new TableColumns()
          ._title('是否为关联客商')
          ._width('150')
          ._data('aa5')
      );
      tableRow.push(
        new TableColumns()
          ._title('信息添加人')
          ._width('150')
          ._data('aa6')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text">删除</el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.accountManagementTable.setColumn(column, {

      });
      this.$refs.accountManagementTable.loadStaticTable(this.tableData, this.tableData.length);
    }
  },
  mounted () {
    this.setTable();
  }
};
</script>
<style lang="scss" scoped>
#accountManagement {
  width: 100%;
  .common_contentBox{
    >.el-button{
      margin-bottom: 10px;
    }
  }
  .el-dialog{
    .el-form{
      &:after{
        content: "";
        clear: both;
        display: block;
        height: 0;
      }
      >.el-form-item{
        width: 50%;
        float: left;
        padding: 0 10px;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
